<template>
  <div>
    <section id="header-banner">
      <img v-lazy="'https://beneat.co/static/img/bigCleaningNew/HEADER.png'" alt="บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ - BeNeat"
           class="header-image d-none d-md-block"/>
      <img v-lazy="'https://beneat.co/static/img/bigCleaningNew/HEADER_MOBILE.png'" alt="บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ - BeNeat (Mobile)"
           class="header-image d-block d-md-none"/>
    </section>

<!--    <section id="promotions mt-3">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h2 class="text-highlight text-title">{{ $t('message.service_request.promotion') }}</h2>
                &lt;!&ndash; Promotion Slider &ndash;&gt;
                <promotion-slider/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <section id="what-big-cleaning-do">
      <div class="container">
        <div class="row">

          <div class="col-12 col-md-6 order-2 order-md-1">
            <div class="card" id="what-big-cleaning-service" >
              <div class="card-body">
                <h2 class="text-center" v-html="$t('message.service_request.what_big_clean_do')"></h2>


                <p style="background: #DBFAFF;" class="p-3">
                  การทำความสะอาดครั้งใหญ่ ทุกห้องที่อยู่ภายในบ้านทุกซอกทุกมุม
                  ทุกพื้นผิวของวัสดุภายในบ้าน เช่น พื้น ผนัง เพดาน ระเบียง กระจก
                  รางกระจก วงกบประตู หน้าต่าง โต๊ะ ตู้ เตียง ที่นอน ชั้นวางของ
                  และเหมารวมทุกห้องที่อยู่ภายในบ้าน
                </p>

                <div class="list-dot">
                  <p>กวาดและเก็บขยะโดยที่นำไปทิ้งยังที่ผู้ว่าจ้างจัดเตรียมไว้</p>
                  <p>ทำความสะอาดเก็บคราบฝุ่นพื้นที่ทั่วไปให้สะอาด</p>
                  <p>ทำความสะอาดเก็บคราบสี/คราบปูน (ถ้ามี) ให้สะอาด</p>
                  <p>ทำความสะอาดผนังบ้านหรือสำนักงานทั้งภายใน/ภายนอก</p>
                  <p>ขัดล้างพื้นเซรามิค, แกรนิตโต้, หินอ่อน, แกรนิต <br> ด้วยเครื่องขัดล้างพื้น พร้อมปัดเงาพื้น</p>
                </div>

                <img src="/static/img/bigCleaningNew/BC_TODO_1.png" alt="ทำความสะอาดทุกซอกทุกมุม ทุกพื้นผิด" class="img-fluid">

                <div class="list-dot">
                  <p>ล้างทำความสะอาดห้องน้ำและสุขภันฑ์</p>
                  <p>ทำความสะอาด ห้องครัวและอุปกรณ์</p>
                  <p>ทำความสะอาดโคมไฟ, ปลั๊กไฟ เฉพาะภายนอก (ไม่รวมโคมไฟระย้า)</p>
                  <p>เช็คทำความสะอาดเฟอร์นิเจอร์ (โต๊ะ เก้าอี้ ตู้ ชั้น ลิ้นชัก) ฯลฯ <br> หรือเฟอร์นิเจอร์อินต่างๆ</p>
                  <p>ทำความสะอาด ดูดฝุ่นพรม (ถ้ามี), วอลเปเปอร์ (ถ้ามี)</p>
                </div>

                <img src="/static/img/bigCleaningNew/BC_TODO_2.png" alt="ทำความสะอาดรอบตัวบ้าน ภายในบ้าน ด้วยอุปกรณ์มืออาชีพ" class="img-fluid">

                <div class="list-dot">
                  <p>เช็คทำความสะอาดกระจกภายในและภายนอกพร้อมขอบเฟรม</p>
                  <p>ทำความสะอาดลานซักล้าง, ทางเดินรอบบ้านและที่จอดรถ</p>
                  <p>ทำความสะอาดมุ้งลวด, เหล็กดัด (ถ้ามี)</p>
                  <p>ล้างทำความสะอาดบริเวณบันไดและเช็ดราวบันไดให้สะอาด</p>
                  <p>การให้บริการทำความสะอาดอื่นๆ ตามที่ตกลง</p>
                </div>

              </div>
            </div>

          </div>

          <div class="col-12 col-md-6 order-1 order-md-2">
            <div class="card">
              <div class="card-body" id="form-service">
                <h2 class="text-center">คำขอใบเสนอราคาบริการ <br> Big Cleaning</h2>

                <div class="d-flex justify-content-between align-items-center mb-3">
                  <p class="my-0">ข้อมูลการติดต่อ</p>
                  <a href="#what-big-cleaning-service">
                    <button type="button" class="btn btn-light btn-sm"> รายละเอียด Big Cleaning</button>
                  </a>
                </div>

                <form @submit.prevent="confirmSubmit">
                  <div class="form-group">
                    <label for="name">ชื่อผู้ติดต่อ <span style="color: red;">*</span></label>
                    <input type="text" class="form-control" id="name" v-model="contactData.name" required>
                  </div>

                  <div class="form-group">
                    <label for="email">อีเมล <span style="color: red;">*</span></label>
                    <input type="email" class="form-control" id="email" v-model="contactData.email" required>
                  </div>

                  <div class="form-group">
                    <label for="tel">เบอร์โทร <span style="color: red;">*</span></label>
                    <input type="tel" maxlength="10" minlength="10"
                           class="form-control" id="tel" v-model="contactData.tel" required>
                  </div>

                  <div class="form-group">
                    <label for="purpose">วัตถุประสงค์การทำ Big Cleaning <span style="color: red;">*</span></label>
                    <!-- <select v-model="contactData.service_request_purpose_id" name="purpose" id="purpose"
                            class="form-control" required>
                      <option value="">กรุณาเลือกวัตถุประสงค์</option>
                      <template v-for="data in globalState.configData.big_cleaning_types">
                        <option :value="data.id">{{ data | multiLangName }}</option>
                      </template>
                    </select> -->

                    <div class="radio-coppy-custom" v-for="data in globalState.configData.big_cleaning_types" :key="data.id">
                      <input type="radio"
                             :id="'ebig-cleaning-radio-id-'+data.id"
                             name="ebig-cleaning-radio"
                             :value="data.id"
                             v-model="contactData.service_request_purpose_id"
                      />
                      <label :for="'ebig-cleaning-radio-id-'+data.id" class="style-lable  py-2 pl-2">
                        <span></span>
                        {{ nameReplase(data) | multiLangName }}
                      </label>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="province">จังหวัด <span style="color: red;">*</span></label>
                    <v-select v-model="contactData.address_province_id"
                              :class="[{'form-alert': errors.has('province_address')}, 'custom-v-select']"
                              v-validate="'required'"
                              :options="addressProvinces"
                              :placeholder="$t('message.service_request.big_cleaning_building_require_province')"
                              label="name_th"
                              ref="province_address"
                              id="province_address"
                              name="province_address"
                              :reduce="addressProvince => addressProvince.id"
                              :selectable="option => option.id > 0"
                              :disabled="disableSelectProvince"
                              @option:selected="clearTyping"
                    >
                      <template v-slot:option="option">
                        {{ option.name_th }}
                      </template>


                      <template #search="{attributes, events}">
                        <input
                          class="vs__search"
                          :required="!contactData.address_province_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="no-options">
                        กรุณาพิมพ์จังหวัดที่ใช้บริการ
                      </template>
                    </v-select>
                  </div>
                  <div class="form-group">
                    <label for="district">อำเภอ<span style="color: red;">*</span></label>
                    <v-select v-model="contactData.district_id"
                              :class="[{'form-alert': errors.has('province_address')}, 'custom-v-select']"
                              v-validate="'required'"
                              :options="addressDistricts"
                              :placeholder="$t('message.service_request.big_cleaning_building_require_district')"
                              label="name_th"
                              ref="district_address"
                              id="district_address"
                              name="district_address"
                              :reduce="addressDistrict => addressDistrict.id"
                              :selectable="option => option.id > 0"
                              :disabled="!contactData.address_province_id || disableSelectDistrict"
                              @option:selected="clearTyping">

                      <template v-slot:option="option">
                        {{ option.name_th }}
                      </template>

                      <template #search="{attributes, events}">
                        <input
                          class="vs__search"
                          :required="!contactData.district_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="no-options">
                        กรุณาพิมพ์อำเภอที่ใช้บริการ
                      </template>

                    </v-select>

                  </div>

                  <div class="form-group">
                    <label for="district">แขวง/ตำบล</label>
                    <v-select v-model="contactData.sub_district_id"
                              :class="[{'form-alert': errors.has('province_address')}, 'custom-v-select']"
                              v-validate="'required'"
                              :options="addressSubDistricts"
                              :placeholder="$t('message.service_request.big_cleaning_building_require_sub_district')"
                              label="name_th"
                              ref="district_address"
                              id="district_address"
                              name="district_address"
                              :reduce="addressDubDistrict => addressDubDistrict.id"
                              :selectable="option => option.id > 0"
                              :disabled="!contactData.district_id || disableSelectSubDistrict"
                              @option:selected="clearTyping">

                      <template v-slot:option="option">
                        {{ option.name_th }}
                      </template>

                    </v-select>
                  </div>

                  <!-- Attach photos -->
                  <div class="row py-3">
                    <div class="col">
                      <h4 class="pb-2">
                        <i class="fal fa-images fa-lg"></i>&nbsp;&nbsp;แนบรูป
                        <!-- <span class="text-danger" v-if="errorNoUploadPhoto">
                          <i class="fa fa-exclamation-circle"></i>
                        </span> -->
                      </h4>
                      <div class="text-remark mb-2">
                        <i class="fas fa-circle fa-sm -status-pending"></i>&nbsp;
                        {{ $t('message.service_request.big_cleaning_attach_photos_remark') }}
                      </div>
                      
                      <vue-dropzone ref="vueDropzone"
                                    id="dropzone"
                                    class="dropzone-dashed"
                                    :options="dropzoneOptions"
                                   />
                      <!-- <div class="mt-2 text-remark -status-alert" v-if="errorNoUploadPhoto">
                        {{ $t('message.required_photo_attachment') }}
                      </div> -->
                    </div>
                  </div>


                  <div class="form-group">
                    <p class="text-orange mb-0">เงื่อนไขการให้บริการ</p>
                    <span>พื้นที่ให้บริการเฉพาะในจังหวัด กรุงเทพฯ และปริมณฑล, เชียงใหม่ และชลบุรีเท่านั้น</span>

                    <p class="text-orange mb-0">หมายเหตุ</p>
                    <span>
                      การส่งคำขอนี้เป็นการส่งเพื่อประเมินราคาไม่ใช่การจองบริการเนื่องจากต้องมีการ
                      เช็คคิวกับทีมงานหลังจากได้ราคาค่าบริการ และวันที่สะดวกเข้าให้บริการแล้วทางบีนีท
                      จะส่งข้อมูลกลับไปให้คุณยืนยัน ถ้าคุณยอมรับราคา และวันที่เข้าให้บริการ
                      คุณจำเป็นต้องชำระเงินค่ามัดจำก่อน 50% เพื่อยืนยันการจอง
                    </span>
                  </div>

                  <div class="form-group">
                    <button class="button button-block button-large -cyan" type="submit"
                            :disabled="isSubmitting">
                      ส่งคำขอประเมินราคา
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="who-cleaning-for">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 add-extra-padding">
            <div class="card">
              <div class="card-body">
                <h2 class="text-center">{{ $t('message.service_request.who_cleaning_for') }}</h2>

                <hr style="border-top: 2px solid #39C9E2;">

                <div class="row">
                  <div class="col-12 col-md-6">
                    <img src="/static/img/bigCleaningNew/B_1.png" alt="เหมาะกับห้องและบ้านที่ไม่ได้ทำความสะอาดมานาน" class="img-fluid">
                  </div>

                  <div class="col-12 col-md-6 d-flex flex-wrap align-content-between">
                    <div class="row">
                      <div class="col-12 text-justify">
                        <span class="text-semi-bold">บริการทำความสะอาดใหญ่ Big Cleaning ของบีนีท</span>
                        เหมาะสำหรับที่พักอาศัย
                        บ้าน คอนโด หรือ สำนักงาน ที่ไม่ได้ทำความสะอาดมานาน ทีมงานมืออาชีพ
                        ของเราจะเข้าไปทำความสะอาดครบจบทุกขั้นตอน ทุกซอกทุกมุมในบ้าน ให้
                        ที่พักของคุณลูกค้าทุกท่านสะอาด หมดจด ตั้งแต่บริเวณภายในบ้าน เช่น ห้องนอน
                        ห้องน้ำ ห้องครัว ต่างๆ ทุกสภาพพื้นผิวและอุปกรณ์ภายในบ้าน ไม่ว่าจะเป็น
                        พื้น ผนัง เพดาน ระเบียง บันได ขอบวงกบประตู หน้าต่าง เฟอร์นิเจอร์
                        เครื่องใช้ไฟฟ้า อื่นๆ รวมถึงบริเวณภายนอกที่อยู่อาศัย ลานจอดรถ ลานซักล้าง
                        เป็นต้น <span class="text-semi-bold">บริการทำความสะอาดใหญ่</span>
                        นั้นจะเป็นการทำความสะอาดที่สะอาด
                        กว่าปกติ ที่ขจัดสิ่งสกปรก คราบฝังลึก และฝุ่นละอองตามซอกต่างๆ ทุกจุดใน
                        บ้านอีกด้วย
                        <div :class="!$mq.phone? 'd-inline-block':'d-block d-flex justify-content-center'">
                          <a href="#form-service">
                            <button type="button" class="btn btn-info py-1 px-1">ประเมินราคา</button>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="d-none d-md-block">
                      <div class="row">
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_2.png" alt="รูปก่อนและหลังการทำความสะอาดตู้เย็น" class="img-fluid">
                        </div>
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_3.png" alt="รูปก่อนและหลังการทำความสะอาดระเบียง" class="img-fluid">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mt-5">
                  <div class="col-12 col-md-6 d-flex flex-wrap align-content-between order-1 order-md-0">
                    <div class="row">
                      <div class="col-12 text-justify">
                        <div>
                          สิ่งที่ควรทำ ก่อน-หลัง ย้ายที่พักอาศัยใหม่ หรือ ที่ทำงาน ก็คือการทำความสะอาดที่พักอาศัย บ้าน
                          คอนโด และสำนักงาน โดยทีมงาน ทำความสะอาดใหญ่บีนีท
                          ถึงแม้ว่าการย้ายเข้าที่พักอาศัยใหม่จะสะอาดอยู่แล้ว แต่อาจจะยังสะอาดไม่พอ เนื่องจากฝุ่น
                          คราบสกปรก และเชื้อโรคต่างๆอาจะยังฝั่งลึกและยังไม่หมดไป
                          ซึ่งก่อนย้ายเข้าที่พักอาศัยหรือบ้านใหม่นั้น
                          ความสะอาดและความปลอดภัยของคนในครอบครัวจึงเป็นสิ่งสำคัญ โดยเฉพาะเฟอร์นิเจอร์ต่างๆ ภายในบ้าน
                          เช่น โซฟา ผ้าม่าน ที่นอน พรม ชั้นวางบิ้วอิน และ ของตกแต่ง
                          ต่างๆภายในบ้าน ยิ่งต้องดูแลและทำความสะอาดเป็นพิเศษ ดังนั้นการ<span class="text-semi-bold">ทำความสะอาดก่อนเข้าอยู่และหลังย้ายออกจึงเป็นสิ่งสำคัญมาก</span>
                          <div :class="!$mq.phone? 'd-inline-block':'d-block d-flex justify-content-center'">
                            <a href="#form-service">
                              <button type="button" class="btn btn-info py-1 px-1">ประเมินราคา</button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-none d-md-block">
                      <div class="row">
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_5.png" alt="รูปก่อนและหลังการทำความสะอาดห้องน้ำ" class="img-fluid">
                        </div>
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_4.png" alt="รูปก่อนแหละหลังการทำความสะอาดระเบียง" class="img-fluid">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 order-0 order-md-1">
                    <img src="/static/img/bigCleaningNew/B_6.png" alt="เหมาะกับห้องและบ้านก่อนเข้าหรือหลังย้ายออก" class="img-fluid">
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12 col-md-6">
                    <img src="/static/img/bigCleaningNew/B_7.png" alt="เหมาะกับห้องและบ้านหลังการก่อสร้างหรือรีโนเวท" class="img-fluid">
                  </div>

                  <div class="col-12 col-md-6 d-flex flex-wrap align-content-between">
                    <div class="row">
                      <div class="col-12 text-justify">
                        <span class="text-semi-bold">บริการทำความสะอาดหลังการก่อสร้างและรีโนเวทที่พักอาศัย</span>
                        ประสบการณ์
                        การทำงานของทีมงานบีนีทที่เป็นมืออาชีพ คุณลูกค้าวางใจได้เลยว่าการ<span class="text-semi-bold">ทำความ
                            สะอาดใหญ่หลังการก่อสร้าง</span> ของบีนีทนั้นจะออกมาดีและสะอาดทุกซอกทุกมุม
                        ตั้งแต่การเก็บกวาดทำความสะอาดฝุ่นผง เศษวัสดุก่อสร้าง เช่น เศษปูน คอนกรีต
                        เหล็ก และไม้ที่หลงเหลือจากงานก่อสร้างหรืองานต่อเติม ขัดล้างพื้นที่เปื้อนปูน
                        คราบกาว สี เก็บกวาดพื้นที่ให้สะอาดหมดจดให้ท่านพร้อมเข้าอยู่หรือเข้าใช้งาน
                        ได้อย่างปลอดภัย ช่วยทำความสะอาดในจุดที่ยากแก่การทำความสะอาด เช่น
                        การทำความสะอาดกระจกในที่สูง หรือสามารถเลือกใช้วิธี และผลิตภันฑ์
                        ทำความสะอาดที่เหมาะสมกับประเภทและชนิดของพื้นผิวได้
                        <div :class="!$mq.phone? 'd-inline-block':'d-block d-flex justify-content-center'">
                          <a href="#form-service">
                            <button type="button" class="btn btn-info py-1 px-1">ประเมินราคา</button>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="d-none d-md-block">
                      <div class="row mt-3">
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_8.png" alt="ห้องหลังก่อสร้างหรือรีโนเวท" class="img-fluid">
                        </div>
                        <div class="col-6">
                          <img src="/static/img/bigCleaningNew/B_9.png" alt="ขัดพื้นด้วยอุปกรณ์มืออาชีพ" class="img-fluid">
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="customer-review">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h2 class="text-center">{{ $t('message.big_cleaning.topic_review') }}</h2>
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-12 ">
                    <img src="static/img/bigCleaningNew/R_3.png" alt="ทำความสะอาดหลังปรับปรุงรีโนเวทบ้าน" class="img-fluid">
                  </div>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-sm-6 d-inline-flex">
                    <img src="static/img/bigCleaningNew/R_1.png" alt="รูปก่อนแหละหลังทำความสะอาด1" class="img-fluid">
                  </div>
                  <div class="col-sm-6 d-inline-flex">
                    <img src="static/img/bigCleaningNew/R_2.png" alt="รูปก่อนแหละหลังทำความสะอาด2" class="img-fluid">
                  </div>
                </div>
              </div>
              <div class="d-block d-flex justify-content-center">
                <a href="#form-service">
                  <button type="button" class="btn btn-info py-1 px-1 mb-3">ประเมินราคา</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <section id="frequently-asked-question" class="section-padding-gray">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-8 col-12">
            <h2 class="text-center">{{ $t('message.big_cleaning.faq_title') }}</h2>
            <!-- Question 1 -->
            <div class="mt-5">
              <h3>{{ $t('message.big_cleaning.faq_topic01') }}</h3>
              <p class="big-cleaning-faq-description">{{ $t('message.big_cleaning.faq_topic01_description') }}</p>
            </div>
            <!-- Question 2 -->
            <div class="mt-5">
              <h3>{{ $t('message.big_cleaning.faq_topic02') }}</h3>
              <p class="big-cleaning-faq-description">{{ $t('message.big_cleaning.faq_topic02_description') }}</p>
            </div>
            <!-- Question 3 -->
            <div class="mt-5">
              <h3>{{ $t('message.big_cleaning.faq_topic03') }}</h3>
              <p class="big-cleaning-faq-description">{{ $t('message.big_cleaning.faq_topic03_description') }}</p>
            </div>
            <div class="mt-5">
              <h3>{{ $t('message.big_cleaning.faq_topic04') }}</h3>
              <p class="big-cleaning-faq-description" v-html="$t('message.big_cleaning.faq_topic04_description')"></p>
            </div>
            <div class="mt-5">
              <h3>{{ $t('message.big_cleaning.faq_topic05') }}</h3>
              <p class="big-cleaning-faq-description">{{ $t('message.big_cleaning.faq_topic05_description') }}</p>
            </div>
          </div>
        </div>
        <div class="d-block d-flex justify-content-center">
          <a href="#form-service">
            <button type="button" class="btn btn-info py-1 px-1">ประเมินราคา</button>
          </a>
        </div>
      </div>
    </section>

    <section id="rate-price">
      <div class="container">
        <!-- อัตราค่าบริการ -->
        <div class="row" style="margin-bottom: 2.5em;">
          <div class="col-12 col-md-6" style="padding: 15px 15px 15px 15px;">
            <img src="static/img/bigCleaningNew/PRICE.png" alt="อัตราค่าบริการ" class="img-fluid">
            <p class="text-secondary text-right">*เป็นราคาเริ่มต้น บริษัทจะประเมินละเอียดอีกครั้งจากหน้างานจริง</p>
          </div>
          <!-- สอบถามรายละเอียดเพิ่มเติม -->
          <div class="align-items-center col-12 col-md-6 d-flex justify-content-center">
            <div class="">
              <div class="d-flex">
                <div class="d-flex flex-column text-center">
                  <img src="static/img/bigCleaningNew/QR_CODE_LINE.png" alt="ติดต่อเจ้าหน้าที่" class="img-fluid">
                  <p class="mb-0">ติดต่อเจ้าหน้าที่</p>
                  <a href="tel:+6621131138" class="text-highlight mb-3">02-113-1138</a>
                  <a class="btn btn-success" href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">LINE ID:
                    @BeNeat</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="d-block d-flex justify-content-center">
        <a href="#header-banner" class="text-center">
          <button type="button" class="btn btn-info" style="border-radius: 25px;">
            <i class="fa fa-chevron-up fa-2x"></i>
          </button>
          <br>
          <span style="color:#32a2b8">BACK TO TOP</span>
        </a>
      </div>
    </section>


  </div>
</template>

<script>
import ImageMessage from '../chatBooking/components/ImageMessage.vue'
import PromotionSlider from '../promotion/Slider'
import { mapGetters } from 'vuex'
import axios from 'axios'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'

export default {
  components: {
    PromotionSlider,
    ImageMessage,
    'v-select': vSelect,
    vueDropzone: vue2Dropzone
  },
  name: 'BigCleaningNew',
  metaInfo () {
    return {
      title: 'BeNeat บริการทำความสะอาดใหญ่ (Big Cleaning) บ้าน คอนโด ออฟฟิศ โรงแรม ครบวงจร ทีมงานมืออาชีพ',
      link: [
        {
          rel: 'canonical',
          href: 'https://beneat.co/big-cleaning'
        }
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'BeNeat ให้บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ สำนักงาน และโรงแรม ครอบคลุมทั้งก่อนและหลังเข้าอยู่ รวมถึงทำความสะอาดหลังการก่อสร้างและรีโนเวท ขจัดคราบฝังแน่น กำจัดไรฝุ่น พ่นฆ่าเชื้อ ซักโซฟา ซักที่นอน ซักผ้าม่าน ซักพรม ด้วยทีมงานมืออาชีพและอุปกรณ์ทันสมัย พร้อมให้บริการในกรุงเทพฯ ปริมณฑล เชียงใหม่ และชลบุรี'
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'BeNeat บริการทำความสะอาดใหญ่ (Big Cleaning) บ้าน คอนโด ออฟฟิศ โรงแรม ครบวงจร ทีมงานมืออาชีพ'
        },
        {
          vmid: 'description',
          name: 'description',
          content: 'BeNeat ให้บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ สำนักงาน และโรงแรม ครอบคลุมทั้งก่อนและหลังเข้าอยู่ รวมถึงทำความสะอาดหลังการก่อสร้างและรีโนเวท ขจัดคราบฝังแน่น กำจัดไรฝุ่น พ่นฆ่าเชื้อ ซักโซฟา ซักที่นอน ซักผ้าม่าน ซักพรม ด้วยทีมงานมืออาชีพและอุปกรณ์ทันสมัย พร้อมให้บริการในกรุงเทพฯ ปริมณฑล เชียงใหม่ และชลบุรี'
        },
        {
          vmid: 'og:image',
          name: 'og:image',
          content: 'https://beneat.co/static/img/bigCleaningNew/HEADER.png'
        },
        {
          vmid: 'image',
          name: 'image',
          content: 'https://beneat.co/static/img/bigCleaningNew/HEADER.png'
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.url
        },
        {
          vmid: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          vmid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          vmid: 'twitter:title',
          name: 'twitter:title',
          content: 'BeNeat บริการทำความสะอาดใหญ่ (Big Cleaning) บ้าน คอนโด ออฟฟิศ โรงแรม ครบวงจร ทีมงานมืออาชีพ'
        },
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: 'BeNeat ให้บริการทำความสะอาดใหญ่ (Big Cleaning) สำหรับบ้าน คอนโด ออฟฟิศ สำนักงาน และโรงแรม ครอบคลุมทั้งก่อนและหลังเข้าอยู่ รวมถึงทำความสะอาดหลังการก่อสร้างและรีโนเวท ขจัดคราบฝังแน่น กำจัดไรฝุ่น พ่นฆ่าเชื้อ ซักโซฟา ซักที่นอน ซักผ้าม่าน ซักพรม ด้วยทีมงานมืออาชีพและอุปกรณ์ทันสมัย พร้อมให้บริการในกรุงเทพฯ ปริมณฑล เชียงใหม่ และชลบุรี'
        },
        {
          vmid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://beneat.co/static/img/bigCleaningNew/HEADER.png'
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: 'th_TH'
        }
      ]
    }
  },
  data () {
    return {
      addressProvinces: [],
      isSubmitting: false,
      contactData: {
        name: '',
        email: '',
        tel: '',
        service_request_purpose_id: '',
        address_province_id: '',
        is_new_form: true,
        district_id: '',
        sub_district_id: ''
      },
      disableSelectProvince: false,
      disableSelectDistrict: false,
      disableSelectSubDistrict: false,
      addressDistricts: [],
      addressSubDistricts: [],
      errorNoUploadPhoto: false,
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: 'https://beneat.co',
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        maxFilesize: 5,
        dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
        headers: { 'Content-Type': 'multipart/form-data' },
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 20
      }
    }
  },
  watch: {
    'contactData.address_province_id': function (newVal) {
      console.log('new value')
      this.getAddressDistrics(newVal)
    },
    'contactData.district_id': function (newVal) {
      this.getAddressSubDistrics(newVal)
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState',
      user: 'auth/getUser'
    })
  },
  methods: {
    clearTyping () {
      this.disableSelectProvince = true
      this.disableSelectDistrict = true
      this.disableSelectSubDistrict = true
      setTimeout(() => {
        this.disableSelectProvince = false
        this.disableSelectDistrict = false
        this.disableSelectSubDistrict = false
      }, 500)
    },
    async getAddressProvinces () {
      // ดึงมาทั้งหมด 77 จังหวัด
      let { data } = await axios.get('/address-provinces?is_all=1')
      if (!data.error) {
        const addressProvinces = [...data.address_provinces]
        // id service top pick
        // [1, 2, 3, 4, 58, 59, 5, 38, 11]

        // For Separate in option
        const provinceService = { id: -1, name_th: 'จังหวัดที่ให้บริการ' }
        addressProvinces.splice(0, 0, provinceService)

        const indexNakornpathom = addressProvinces.findIndex(item => item.id === 58)
        this.moveIndexArrayItem(addressProvinces, indexNakornpathom, 5)

        const indexSamutsakorn = addressProvinces.findIndex(item => item.id === 59)
        this.moveIndexArrayItem(addressProvinces, indexSamutsakorn, 6)

        const indexChiangmai = addressProvinces.findIndex(item => item.id === 38)
        this.moveIndexArrayItem(addressProvinces, indexChiangmai, 8)

        const indexChonburi = addressProvinces.findIndex(item => item.id === 11)
        this.moveIndexArrayItem(addressProvinces, indexChonburi, 9)

        const otherProvince = { id: -2, name_th: 'จังหวัดอื่นๆ' }
        addressProvinces.splice(10, 0, otherProvince)

        this.addressProvinces = [...addressProvinces]
      } else {
        this.$swal({ text: 'No Data', type: 'error' })
      }
    },
    async getAddressDistrics (provinceId) {
      console.log('id province', provinceId)
      let { data } = await axios.get(`/districts?province_id=${provinceId}`)
      if (!data.error) {
        this.addressDistricts = data.districts
        // console.log(data)
      }
    },
    async getAddressSubDistrics (districId) {
      let { data } = await axios.get(`/sub-districts?district_id=${districId}`)
      if (!data.error) {
        this.addressSubDistricts = data.sub_districts
        // console.log('sub-distric', data)
      }
    },
    clearFileUploadError (file) {
      this.errorNoUploadPhoto = false
    },
    moveIndexArrayItem (arr, fromIndex, toIndex) {
      const element = arr[fromIndex]
      arr.splice(fromIndex, 1)
      arr.splice(toIndex, 0, element)
    },
    confirmSubmit () {
      this.$swal({
        title: this.$i18n.t('message.service_request.big_cleaning_service_confirm_title'),
        text: this.$i18n.t('message.service_request.big_cleaning_service_confirm_description'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#9E9E9E',
        reverseButtons: true,
        confirmButtonText: this.$i18n.t('message.confirm.yes'),
        cancelButtonText: this.$i18n.t('message.confirm.cancel')
      }).then(() => {
        this.submitForm()
      })
    },
    async submitForm () {
      this.isSubmitting = true
      let url = 'service-requests/form-service-request'
      // this.errorNoUploadPhoto = (this.$refs.vueDropzone.getQueuedFiles().length === 0)
      try {
        let formData = new FormData()
        formData.append('name', this.contactData.name)
        formData.append('email', this.contactData.email)
        formData.append('tel', this.contactData.tel)
        formData.append('service_request_purpose_id', this.contactData.service_request_purpose_id)
        formData.append('address_province_id', this.contactData.address_province_id)
        formData.append('district_id', this.contactData.district_id)
        if (this.contactData.sub_district_id) {
          formData.append('sub_district_id', this.contactData.sub_district_id)
        }
        if (this.$route.query.admin_id && this.$route.query.reference) {
          this.contactData.admin_id = Number(this.$route.query.admin_id)
          this.contactData.reference = this.$route.query.reference
          formData.append('admin_id', this.contactData.admin_id)
          formData.append('reference', this.contactData.reference)
        }
        this.errorNoUploadPhoto = (this.$refs.vueDropzone.getQueuedFiles().length === 0)
        console.log('error no upload', this.errorNoUploadPhoto)
        if (!this.errorNoUploadPhoto) {
          const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
          for (let key in queueFiles) {
            formData.append('upload_image[]', queueFiles[key])
          }
        }
        console.log('formData', this.contactData)
        const { data } = await axios.post(url, formData, {headers: { 'Content-Type': 'multipart/form-data' }})
        if (data.error) {
          throw new Error(data.message)
        }
        this.isSubmitting = false
        this.$router.push({ path: '/big-cleaning/thank', replace: true })
      } catch (err) {
        console.log('error log', err.message)
        this.$swal({ text: 'เกิดข้อผิดพลาด กรุณาติดต่อทีมงาน', type: 'error' })
      }
    },
    nameReplase (data) {
      if (!data) return
      data.name_th = data.name_th.replace('ทำความสะอาด', '')
      return data
    }
  },
  created () {
    this.getAddressProvinces()
    // Taboola tracking code
    window._tfa = window._tfa || []
    window._tfa.push({ notify: 'event', name: 'page_view', id: 1490322 })
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";
@import "~vue-select/dist/vue-select.css";

.text-semi-bold {
  font-weight: 500;
}

.text-title {
  font-size: 2rem;
  margin: 20px 0;
  text-align: center;
}

.text-orange {
  color: #FF6813;
}

.text-highlight {
  color: #00BCD5;
}

section#header-banner img.header-image {
  width: 100%;
  max-height: 700px;
}

#customer-review img {
  width: 100%;
  padding: 3px;
}

section#what-big-cleaning-do {
  div.list-dot {
    text-align: left;
    margin: 2rem 0;
    margin-left: 20px;

    p {
      line-height: 16px;

      &:before {
        content: "\2022";
        background-color: #39C9E2;
        color: #39C9E2;
        border-radius: 100%;
        display: inline-block;
        height: 13px;
        width: 13px;
        margin-left: -1em;
        margin-right: 10px;
      }
    }
  }
}

section#who-cleaning-for {
  div.add-extra-padding {
    padding: 0 30px;
  }
}


@include media-breakpoint-down(md) {
  section#who-cleaning-for {
    div.container-fluid {
      padding: 0;
    }

    div.add-extra-padding {
      padding: 0;
    }
  }
  .style-lable {
    padding: 7px !important;
    // border: 1px solid rgb(206,212,218);
    // border-radius: 5px;
    // box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.075);
  }
}

.radio-coppy-custom {
  display: table;
  width: 100%;
  height: 100%;
}

.radio-coppy-custom label span {
  display: inline-block;
  position: relative;
  background-color: transparent;
  width: 20px;
  height: 20px;
  transform-origin: center;
  border: 2px solid #3bbcd4;
  border-radius: 50%;
  vertical-align: -6px;
  margin-right: 10px;
}

.radio-coppy-custom label span:before {
  content: "";
  width: 0px;
  height: 2px;
  border-radius: 2px;
  background: #3bbcd4;
  position: absolute;
  transform: rotate(45deg);
  top: 8px;
  left: 5px;
  transition: width 50ms ease 50ms;
  transform-origin: 0% 0%;
}

.radio-coppy-custom label span:after {
  content: "";
  width: 0;
  height: 2px;
  border-radius: 2px;
  background: #118aee;
  position: absolute;
  transform: rotate(305deg);
  top: 12px;
  left: 6px;
  transition: width 50ms ease;
  transform-origin: 0% 0%;
}

.radio-coppy-custom input[type="radio"] {
  display: none;
}

.radio-coppy-custom input[type="radio"]:checked + label span {
  background-color: #3bbcd4;
  transform: scale(1.2);
}

.radio-coppy-custom input[type="radio"]:checked + label span:after {
  width: 10px;
  background: #fff;
  transition: width 150ms ease 100ms;
}

.radio-coppy-custom input[type="radio"]:checked + label span:before {
  width: 5px;
  background: #fff;
  transition: width 150ms ease 100ms;
}
</style>



// WEBPACK FOOTER //
// src/components/information/BigCleaningNew.vue